import http from '@/communication/AuthConnection'

export default async ({ state, commit }, payload) => {
  try {
    const result = await http.post(`/v1/item-pricing/remove-dynamic-group`, payload)
    return result.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/remove-dynamic-group/index.js